<template>
    <div class="banner">
        <img v-if="referralProgramId === ReferralProgram.ReferralAward"
            :src="birdDog1x"
            :srcset="birdDog1x + ' 1x, ' + birdDog2x + ' 2x'"
            alt="referral banner image">
        <img v-if="referralProgramId === ReferralProgram.NonMonetary"
            :src="nonMonetary1x"
            :srcset="nonMonetary1x + ' 1x, ' + nonMonetary2x + ' 2x'"
            alt="referral banner image">
        <img v-if="referralProgramId === ReferralProgram.GiveAndGet"
            :src="giveGet1x"
            :srcset="giveGet1x + ' 1x, ' + giveGet2x + ' 2x'"
            alt="referral banner image">
    </div>
</template>

<script>
import { ReferralProgramType } from '../../shared/enums/referral.enum'
import birdDog1x from '../../assets/raf/bird-dog_1x.png'
import birdDog2x from '../../assets/raf/bird-dog_2x.png'
import nonMonetary1x from '../../assets/raf/non-monetary_1x.png'
import nonMonetary2x from '../../assets/raf/non-monetary_2x.png'
import giveGet1x from '../../assets/raf/give-get_1x.png'
import giveGet2x from '../../assets/raf/give-get_2x.png'

export default {
  name: 'referral-program-banner',
  props: {
    referralProgramId: {
      type: Number
    }
  },
  data () {
    return {
      ReferralProgram: ReferralProgramType,
      birdDog1x,
      birdDog2x,
      nonMonetary1x,
      nonMonetary2x,
      giveGet1x,
      giveGet2x
    }
  }
}
</script>

<style scoped>
    img{
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// referral-program-banner.vue?508a3efe